export const Package = {
  Good: 'Good',
  Better: 'Better',
  Best: 'Best',
  Legacy: 'Legacy'
};
